import ComingSoon from '@Components/General/Feedback/ComingSoon';
import { createFileRoute } from '@tanstack/react-router';

// E.g. Donations, Tuition, Payments, etc.
export const Route = createFileRoute('/donations/categories')({
    component: ComingSoon,
});
